import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import RegLayout from "../components/Registration/Layout/Layout";
import RegistrationHome from "../components/Registration/RegistrationHome/RegistrationHome";
import WelcomeBack from "../components/Registration/WelcomeBack/WelcomeBack";
import MailVerified from "../components/Registration/MailVerified/MailVerified";
import NRI from "../components/Registration/NRI/NRI";
import OTP from "../components/Registration/OTP/OTP";
import AccExists from "../components/Registration/AccExists/AccExists";
import PANInfo from "../components/Registration/PANInfo/PANInfo";
import Error from "../components/UI/ErrorScreen/ErrorScreen";
import ShareAdd from "../components/Registration/ShareAdd/ShareAdd";
import DgLocker from "../components/Registration/DgLocker/DgLocker";
import { containerUrl } from "../components/utils/constants";
import useQuery from "../customHooks/useQuery";
import { ClevertapService } from "../components/Services/clevertapService";
import { AppsFlyerService } from "../components/Services/appsFlyerService";
import InstanHelp from "../components/InstantHelp/InstantHelp";
import AccountType from "../components/Registration/AccountType/AccountType";
import AccountTypeNew from "../components/Registration/AccountType/AccountTypeNew";
import DeviceContext from "../components/Services/identifyDevice";
const RegistrationRoutes = () => {
  const quryParams = useQuery();
  const utm_placement = quryParams.get("utm_placement")
    ? quryParams.get("utm_placement")
    : "";

  useEffect(() => {
    getCleverTapIDFromService();
  }, []);

  const getCleverTapIDFromService = async () => {
    // const id =  utm_placement || await ClevertapService.getCleverTapID();
    // const utmObj = JSON.parse(window.sessionStorage.getItem("objUTM_Info") || '{}');
    // window.sessionStorage.setItem("objUTM_Info", JSON.stringify({
    //     ...utmObj,
    //     ...{
    //         utm_placement: id
    //     }
    // }));
    // // Now we need to initilise CUID with AppsFlyer
    // AppsFlyerService.setCUID(id);
  };

  return (
    <>
      <Routes>
        <Route
          path={containerUrl.continue}
          element={
            <InstanHelp panPageFlag={false}>
              <RegLayout>
                <WelcomeBack />
              </RegLayout>
            </InstanHelp>
          }
        />
        <Route
          path={containerUrl.newLanding}
          element={
            <RegLayout
              headerLogoClassName={
                DeviceContext()?.isMobile ? "headerLogo" : "headerLogoNew"
              }
              regOutNewClassName="regLayoutNew"
            >
              <AccountTypeNew />
            </RegLayout>
          }
        />
        {/* <Route
          path={containerUrl.newLandingSample}
          render={(props) => (
            <RegLayout headerLogoClassName="headerLogoNew" regOutNewClassName="regLayoutNew">
              <AccountTypeNew {...props} />
            </RegLayout>
          )}
        /> */}
        <Route
          path={containerUrl.pan}
          element={
            <InstanHelp panPageFlag={true}>
              <RegLayout>
                <PANInfo />
              </RegLayout>
            </InstanHelp>
          }
        />
        <Route
          path={containerUrl.otp}
          element={
            <RegLayout>
              <OTP />
            </RegLayout>
          }
        />
        <Route
          path={containerUrl.accexists}
          element={
            <InstanHelp panPageFlag={false}>
              <RegLayout>
                <AccExists />
              </RegLayout>
            </InstanHelp>
          }
        />

        <Route
          path={containerUrl.dgLocker}
          element={
            <InstanHelp panPageFlag={false}>
              <RegLayout supportNeeded>
                <DgLocker />
              </RegLayout>
            </InstanHelp>
          }
        />
        <Route
          path={containerUrl.showDocuments}
          element={
            <InstanHelp panPageFlag={false}>
              <RegLayout supportNeeded>
                <ShareAdd />
              </RegLayout>
            </InstanHelp>
          }
        />
        <Route
          path={containerUrl.mailVerified}
          element={
            <RegLayout>
              <MailVerified />
            </RegLayout>
          }
        />
        <Route
          path={containerUrl.error}
          element={
            <RegLayout>
              <Error />
            </RegLayout>
          }
        />
        <Route
          path={containerUrl.nri}
          element={
            <RegLayout>
              <NRI />
            </RegLayout>
          }
        />
        <Route
          path={containerUrl.partner}
          element={
            <InstanHelp panPageFlag={false}>
              <RegLayout>
                <RegistrationHome />
              </RegLayout>
            </InstanHelp>
          }
        />
        <Route
          path={containerUrl.opclient}
          element={
            <InstanHelp panPageFlag={false}>
              <RegLayout>
                <RegistrationHome />
              </RegLayout>
            </InstanHelp>
          }
        />
        <Route
          path={containerUrl.registration}
          element={
            <InstanHelp panPageFlag={false}>
              <RegLayout>
                <RegistrationHome />
              </RegLayout>
            </InstanHelp>
          }
        />
      </Routes>
    </>
  );
};

export default RegistrationRoutes;
